export default __webpack_public_path__ + "static/blob-15-0caf3f18839d6106a37279c5ebaf7c11.svg";